import AllResults from './AllResults';

export default AllResults;
